import styled from 'styled-components';
import { IonChip } from '@ionic/react';

export const IonChipWrapper = styled(IonChip)`
  --background: none;

  .avatar {
    pointer-events: none;
  }
`;
